'use client';

import { useSelector } from '@xstate/react';
import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { Modal } from '@flipster/react/design-system-legacy/modal';

import MfaVerifyFlowModalContent from './MfaVerifyFlowModalContent';
import { mfaVerifyFlowBunja } from './bunja';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: (mfaSessionToken: string) => unknown;
  onExit: () => void;
}

const MfaVerifyFlow = ({ isOpen, onClose, onConfirm, onExit }: Props) => {
  const { mfaVerifyActorAtom } = useBunja(mfaVerifyFlowBunja);
  const mfaVerifyActor = useAtomValue(mfaVerifyActorAtom);

  const { isLoading, isMfaRegisterPhase, isMfaPhase, isPasskeyPhase } = useSelector(mfaVerifyActor, (snapshot) => ({
    isLoading: snapshot.matches('INITIATING'),
    isMfaRegisterPhase: snapshot.matches('REQUIRE_MFA'),
    isMfaPhase: snapshot.matches('VERIFYING') || snapshot.matches('WAIT_FOR_DONE'),
    isPasskeyPhase: snapshot.matches('PASSKEY'),
  }));

  const handleClose = () => {
    onClose();
  };

  if (!(isLoading || isMfaRegisterPhase || isMfaPhase || isPasskeyPhase)) return null;

  return (
    <Modal isOpen={isOpen} css={{ minH: 538 }} onExit={onExit}>
      <Modal.Close onClose={handleClose} />
      <MfaVerifyFlowModalContent onClose={onClose} onConfirm={onConfirm} />
    </Modal>
  );
};

export default MfaVerifyFlow;
